<script lang="ts" setup>

    import { useConfigurationStore } from "~/stores/configurationStore";
    import { createGtmHeadScripts } from "~/helpers/GtmHelper";
    import { logError } from "~/utils/logging";

    const nuxtApp = useNuxtApp();
    const loading = ref(true);

    const configurationStore = useConfigurationStore();

    onMounted(async () => {

        const configuration = configurationStore.config;
        const gtmProperties = configuration?.gtmProperties;
        if (!gtmProperties) {
            logError("[GTM] Initialization skipped", new Error("Missing GTM configuration"));
            return;
        }

        // New Relic (RUM) is injected earlier in plugins/03.newrelic-browser.client.ts
        // so early-boot errors are captured. GTM stays here (analytics, not error monitoring).
        useHead({
            script: createGtmHeadScripts(gtmProperties),
        });
    })

    nuxtApp.hook("page:start", () => {
        loading.value = true;
    });

    nuxtApp.hook("page:finish", () => {
        loading.value = false;
    });

    nuxtApp.hook("app:mounted", () => {
        // Event is fired when the app is mounted
    });

</script>
<template>
    <NuxtLayout />
</template>